import moment from 'moment-timezone';
import React from 'react';

export function getDateTimeForZone(date, zone, startOfDay = true) {
    const dateObject = typeof date === 'string' ? new Date(date) : date;
    let d1 = moment(dateObject);
    let d2 = d1.clone();
    d2.tz(zone);
    d2.set('hours', startOfDay ? 0 : 23);
    d2.set('minutes', startOfDay ? 0 : 59);
    d2.set('seconds', startOfDay ? 0 : 59);

    return d2;
}

export function getDaysOfWeek(current, zone) {
    if (!zone) {
        console.warn('tz not defined! setting to: ' + current.tz());
    }

    zone = zone ? zone : current.tz();

    const today = moment.tz(current, zone);
    const monday = today.clone().startOf('isoWeek');

    const days = [monday];
    for (let i = 1; i < 7; i++) {
        days.push(monday.clone().add(i, 'days'));
    }

    days[6]
        .set('hours', 23)
        .set('minutes', 59)
        .set('seconds', 59);

    return days;
}

export function isWeekend(date) {
    return ['Sunday', 'Saturday'].includes(moment(date).format('dddd'));
}

export function getYearWeek(date) {
    let momentDate = moment(date);

    let year = momentDate.year();
    let week = momentDate.isoWeek();
    week = week.toString().length === 1 ? `0${week}` : week.toString();

    return Number.parseInt(`${year}${week}`, 10);
}

export function getRelativeWeek(current, direction) {
    return moment(current).add(direction * 7, 'days');
}

export function isCurrentWeek(current) {
    let range = getWeekRange(current);
    return current >= range.from && current <= range.to;
}

export function isSameWeek(selected, compared) {
    let range1 = getWeekRange(selected);
    let range2 = getWeekRange(compared);

    return isSameDay(range1.from, range2.from) && isSameDay(range1.to, range2.to);
}

export function isSameDay(selected, compared) {
    return moment(selected).isSame(moment(compared), 'day');
}

export function getWeekRange(date) {
    let days = getDaysOfWeek(date);
    const from = days[0];
    const to = days[6];

    return { from, to };
}

/**
 * Convert minutes to a time in format hh:mm
 * Returned value is in range 00  to 24 hrs
 * @param {Number} minutes
 */
export function timeFromMinutes(minutes, upTo24 = true) {
    let format = n => (n < 10 ? '0' : '') + n;

    let h = (minutes / 60) | 0;
    if (upTo24) {
        h = h % 24;
    }

    let m = Math.round(minutes % 60);

    return `${format(h)}:${format(m)}`;
}

export function sortByDate(list, property, ascending) {
    if (!Array.isArray(list) || list.length <= 1) {
        return list;
    }

    return ascending
        ? list.sort((a, b) => {
              if (a[property] > b[property]) {
                  return 1;
              }
              if (a[property] < b[property]) {
                  return -1;
              }
              return 0;
          })
        : list.sort((b, a) => {
              if (a[property] > b[property]) {
                  return 1;
              }
              if (a[property] < b[property]) {
                  return -1;
              }
              return 0;
          });
}

export function timeObjectToMinutes(time) {
    if (!time) {
        return 0;
    }

    let hours = Number.parseInt(time.hours, 10);
    let minutes = Number.parseInt(time.minutes, 10);
    if (time.period === 'PM') {
        if (hours !== 12) {
            hours += 12;
        }
    } else {
        if (hours === 12) {
            hours = 0;
        }
    }

    return minutes + hours * 60;
}

export function minutesFraction(mins) {
    switch (parseInt(mins, 10)) {
        case 15:
            return (
                <div className="fraction">
                    <sup>1</sup>&frasl;<sub>4</sub>
                </div>
            );
        case 30:
            return (
                <div className="fraction">
                    <sup>1</sup>&frasl;<sub>2</sub>
                </div>
            );
        case 45:
            return (
                <div className="fraction">
                    <sup>3</sup>&frasl;<sub>4</sub>
                </div>
            );
        default:
            return null;
    }
}

export function timeObjectFromMinutes(minutes, includePeriod = true) {
    let time = {
        hours: 0,
        minutes: 0,
        period: undefined
    };

    time.minutes = minutes % 60;
    let totalHours = (minutes - time.minutes) / 60;

    if (includePeriod) {
        if (totalHours <= 11) {
            time.hours = totalHours;
            time.period = 'AM';
        } else if (totalHours === 12) {
            time.hours = totalHours;
            time.period = 'PM';
        } else {
            time.hours = totalHours - 12;
            time.period = 'PM';
        }
    } else {
        time.hours = totalHours;
    }

    time.minutes = time.minutes.toString().length === 1 ? `0${time.minutes}` : time.minutes.toString();
    time.hours = time.hours.toString().length === 1 ? `0${time.hours}` : time.hours.toString();

    return time;
}

export function timeObjectFromMoment(time) {
    return {
        hours: time.format('hh'),
        minutes: time.format('mm'),
        period: time.format('A')
    };
}

export function timeRecordToInitialValues(record) {
    if (!record) return {};

    const { minutes, time_in } = record;

    let start = moment(time_in);
    let end = moment(time_in).add(minutes, 'minutes');

    let eo = timeObjectFromMinutes(end.hours() * 60 + end.minutes(), true);

    let values = {
        ...record,
        startTime: timeObjectFromMinutes(start.hours() * 60 + start.minutes(), true),
        endTime: eo
    };

    return values;
}



// WEBPACK FOOTER //
// ./src/utilities/time.jsx